module.exports = __webpack_public_path__ + "public/img/fangaungy.b1e1e324.png";